<template>

  <div class="is-flex columns section-details">
    <div class="corps column is-10">
      <qd-notification ref="element" :closable="false"
                      class="has-background-background is-paddingless">
        <stepper  :steps="tabFilArianeDcf"
                  :last-active-step="getLastActiveStep"
                  :actual-step="1">
        </stepper>
      </qd-notification>
      <informations-generales :info="detailCommandeVenteInterne.generalInfos"
                              :devisCommande="commandeVenteInterne"
                              :type="commandeVenteInterne.type"/>
      <client-payeur :payeurs="detailCommandeVenteInterne.payeurs"
                     :afficherLienDetail="activeButtonEtLien"
                     :intervenantsNonPayeurs="detailCommandeVenteInterne.intervenants"
                     class="mgt-20px"/>
      <detail-devis-commande :devisCommande="commandeVenteInterne"
                             :isPrevisualisation="false"
                             :isEditPrevisu="false"
                             :detailDevisCommande="detailCommandeVenteInterne"
                             :payeurSelected="payeurSelected">
      </detail-devis-commande>
      <div class="card mgt-20px" id="attachments">
        <header class="header-card">
          <p>
            {{ $t('piecesJointes.attachments')}}
          </p>
        </header>
        <div class="card-content">
          <app-pieces-jointes readOnly
                              deletable
                              :canAddOrDeletePj="activeButtonEtLien"
                              autoSave
                              :checkPermissions=checkPermissions(constantes.COMMANDES.maj) />
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="sticky-20px">
        <dots-menu :steps="steps">
        </dots-menu>
        <information-create-update-user :data="commandeVenteInterne">
        </information-create-update-user>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import DotsMenu from '@/components/general/dotsMenu';
import AppPiecesJointes from '@/components/general/piecesJointes';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import InformationsGenerales from '@/components/devisCommandes/detailDevisCommande/informationsGenerales';
import ClientPayeur from '@/components/devisCommandes/detailDevisCommande/clientPayeur';
import detailDevisCommande from '@/components/devisCommandes/detailDevisCommande/detailEditionDevisCommande';
import { REGIE } from '@/configuration/societe/societe';
import stepper from '@/components/devisCommandeFacture/detail/stepper/stepper';
import createFilArianeCommande from '@/services/dcf/detail/filAriane/createFilArianeCommande';

const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'CommandeVenteInterneDetail',
  props: {
    commandeVenteInterne: {
      type: Object,
      required: true,
    },
    detailCommandeVenteInterne: {
      type: Object,
      required: true,
    },
    payeurSelected: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tabFilArianeDcf: [],
      constantes: {
        COMMANDES,
        REGIE,
      },
      steps: [
        {
          name: this.$i18n.t('detailCommande.achatVenteInterne.vente.steps.infoGenerales'),
          ref: '#detail-general',
          active: true,
        },
        {
          name: this.$i18n.t('detailCommande.achatVenteInterne.vente.steps.client'),
          ref: '#detail-client',
          active: false,
        },
        {
          name: this.$i18n.t('detailCommande.achatVenteInterne.vente.steps.commande'),
          ref: '#detail-command',
          active: false,
        },
        {
          name: this.$i18n.t('detailCommande.achatVenteInterne.vente.steps.echeancierFacturation'),
          ref: '#detail-schedule',
          active: false,
        },
        {
          name: this.$i18n.t('detailCommande.achatVenteInterne.vente.steps.pj'),
          ref: '#attachments',
          active: false,
        },
      ],
    };
  },
  components: {
    DotsMenu,
    AppPiecesJointes,
    InformationCreateUpdateUser,
    InformationsGenerales,
    ClientPayeur,
    detailDevisCommande,
    stepper,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    activeButtonEtLien() {
      return this.checkIfCurrentSociety(this.commandeVenteInterne.societeId);
    },
    getLastActiveStep() {
      const tabFilArianceDcfCloneDeep = cloneDeep(this.tabFilArianeDcf);
      tabFilArianceDcfCloneDeep.splice(0, 1);
      const indexFirstStepNotActive = tabFilArianceDcfCloneDeep.findIndex((filAriane) => {
        return !filAriane.isActive;
      });
      return indexFirstStepNotActive;
    },
  },
  methods: {
    loadFilArianne() {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.element.$el,
      });
      createFilArianeCommande(this.commandeVenteInterne, true)
        .then((rsltTabAriane) => {
          this.tabFilArianeDcf = rsltTabAriane;
          loadingComponent.close();
        })
        .catch((e) => {
          loadingComponent.close();
          throw e;
        });
    },
  },
  mounted() {
    this.loadFilArianne();
  },
};

</script>
